import { render, staticRenderFns } from "./ArgInputJournal.vue?vue&type=template&id=2d741bb6"
import script from "./ArgInputJournal.vue?vue&type=script&lang=ts"
export * from "./ArgInputJournal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports